import { Skeleton } from '@avanta/shared/components/ui/Skeleton';
import { StepSection } from '../../ui/StepSection';

const FIELDS_PER_SECTION = 4;

const SelectFieldSkeleton = (): React.ReactElement => (
  <div className="flex flex-col gap-2">
    <Skeleton className="h-3.5 w-24" />
    <Skeleton className="h-10 w-full rounded-lg" />
  </div>
);

export const DataStepSkeleton = (): React.ReactElement => (
  <div className="flex flex-col gap-10 w-3xl">
    <StepSection
      title={<Skeleton className="h-5 w-40" />}
      className="grid grid-cols-2 gap-6"
      containerClassName="w-full"
    >
      {Array.from({ length: FIELDS_PER_SECTION }).map((_, index) => (
        <SelectFieldSkeleton key={`select-${index}`} />
      ))}
    </StepSection>
    <div className="flex w-full justify-end">
      <Skeleton className="h-10 min-w-37 w-37 rounded-[20px]" />
    </div>
  </div>
);
